"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../../common/helpers/time");
var AdminStudentPurchasedTimeController = /** @class */ (function () {
    function AdminStudentPurchasedTimeController($state, $stateParams, UsersModel, FlashService, sessiontypes, coursetypes) {
        var _this = this;
        this.initialLoad = true;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.submitted = false;
        this.sessiontypes = [];
        this.coursetypes = [];
        this.studentId = $stateParams.userId;
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            sessiontypes.forEach(function (sessionType) {
                if (sessionType.allow_observations === false) {
                    var purchasedHours = response.purchasedtime.filter(function (time) {
                        return (time.session_type_id !== null &&
                            time.sessiontype.id === sessionType.id &&
                            time.observation === false);
                    });
                    var durMoment = _this.parseDuration(purchasedHours);
                    _this.sessiontypes.push({
                        name: sessionType.name,
                        id: sessionType.id,
                        hours: durMoment[0],
                        observation: false,
                        minutes: typeof durMoment[1] === "undefined" ? 0 : durMoment[1],
                    });
                }
                else {
                    var purchasedHours = response.purchasedtime.filter(function (time) {
                        return (time.session_type_id !== null &&
                            time.sessiontype.id === sessionType.id &&
                            time.observation === false);
                    });
                    var durMoment = _this.parseDuration(purchasedHours);
                    _this.sessiontypes.push({
                        name: sessionType.name,
                        id: sessionType.id,
                        hours: durMoment[0],
                        observation: false,
                        minutes: typeof durMoment[1] === "undefined" ? 0 : durMoment[1],
                    });
                    var purchasedObservationHours = response.purchasedtime.filter(function (time) {
                        return (time.session_type_id !== null &&
                            time.sessiontype.id === sessionType.id &&
                            time.observation === true);
                    });
                    durMoment = _this.parseDuration(purchasedObservationHours);
                    _this.sessiontypes.push({
                        name: sessionType.name,
                        id: sessionType.id,
                        hours: durMoment[0],
                        observation: true,
                        minutes: typeof durMoment[1] === "undefined" ? 0 : durMoment[1],
                    });
                }
            });
            coursetypes.forEach(function (courseType) {
                var purchasedHours = response.purchasedtime.filter(function (time) {
                    return (time.course_type_id !== null && time.coursetype.id === courseType.id);
                });
                var durMoment = _this.parseDuration(purchasedHours);
                _this.coursetypes.push({
                    name: courseType.name,
                    id: courseType.id,
                    hours: durMoment[0],
                    minutes: typeof durMoment[1] === "undefined" ? 0 : durMoment[1],
                });
            });
            _this.initialLoad = false;
        });
    }
    AdminStudentPurchasedTimeController.prototype.parseDuration = function (purchasedHours) {
        if (typeof purchasedHours[0] !== "undefined") {
            var duration = (0, time_1.minutesToHoursAndMinutes)(purchasedHours[0].hours);
            return [duration.hours, duration.minutes];
        }
        return [0, 0];
    };
    AdminStudentPurchasedTimeController.prototype.save = function () {
        var _this = this;
        this.submitted = true;
        var payload = {
            updatedSessionHours: this.sessiontypes.map(function (s) { return ({
                id: s.id,
                hours: parseInt(String(s.hours), 10),
                minutes: parseInt(String(s.minutes), 10),
                observation: s.observation,
            }); }),
            updatedCourseHours: this.coursetypes.map(function (c) { return ({
                id: c.id,
                hours: parseInt(String(c.hours), 10),
                minutes: parseInt(String(c.minutes), 10),
            }); }),
        };
        this.UsersModel.updatePurchasedTime(this.studentId, payload)
            .then(function () {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: "Purchased time updated successfully.",
            });
            _this.$state.go("drivecoach.admin.students.view", { userId: _this.studentId }, { reload: true });
        })
            .catch(function () {
            _this.submitted = false;
        });
    };
    return AdminStudentPurchasedTimeController;
}());
AdminStudentPurchasedTimeController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "sessiontypes",
    "coursetypes",
];
exports.default = AdminStudentPurchasedTimeController;
